import React, { Component } from "react";

class ProductCanvas extends Component {
  constructor(props) {
    super(props);
    this.canvas = React.createRef();
    this.state = {
      canvasWidth: 290 * 4,
      canvasHeight: 120 * 4,
      implantBoxOffsetY: 0,
      implantGraphOffsetX: 15 * 7,
      implantGraphOffsetY: 0 + 60,
      implantGraphSizeX: 210 * 4.5,
      implantGraphSizeY: 80 * 4 + 60,
      implantSizeX: 180 * 4.5,
      implantSizeY: 45 * 4.5,
      lineWidthXPos: 0,
      implantBottomCornerCurves: 0.4,
      implantCurveBreakPoint: 0.26,
      ctx: false,
      colors: {
        stroke1: "grey",
        stroke2: "black",
        green: "rgb(196, 225, 129)",
        background: "white"
      }
    };
  }

  drawLines = () => {
    const { ctx, implantGraphSizeX, implantGraphSizeY } = this.state;

    for (let i = 1; i < implantGraphSizeY; i += 40) {
      ctx.font = "48px Arial";
      ctx.moveTo(0, i);
      ctx.lineTo(implantGraphSizeX, i);
    }
    ctx.strokeStyle = "#e7e7e7";
    ctx.stroke();
  };

  drawLineWidth = implantHeight => {
    const {
      ctx,
      lineWidthXPos,
      implantGraphSizeY,
      implantGraphSizeX
    } = this.state;
    ctx.save();
    ctx.beginPath();
    ctx.strokeStyle = "#20619b";
    ctx.lineWidth = 8;
    ctx.moveTo(lineWidthXPos - 4 * 4, implantGraphSizeY);
    ctx.lineTo(lineWidthXPos + 4 * 4, implantGraphSizeY);
    // for (let i = implantHeight; i > 0; i -= 5 * 4) {
    //   ctx.moveTo(lineWidthXPos - 3 * 4, implantGraphSizeY - i);
    //   ctx.lineTo(lineWidthXPos + 3 * 4, implantGraphSizeY - i);
    // }
    ctx.moveTo(lineWidthXPos - 4 * 4, implantGraphSizeY - implantHeight);
    ctx.lineTo(lineWidthXPos + 4 * 4, implantGraphSizeY - implantHeight);
    ctx.moveTo(lineWidthXPos, implantGraphSizeY);
    ctx.lineTo(lineWidthXPos, implantGraphSizeY - implantHeight);
    ctx.stroke();
    ctx.fillStyle = "black";
    ctx.textAlign = "center";
    ctx.font = "bold 40pt Arial";
    ctx.textBaseline = "middle";
    let offset = implantGraphSizeY - implantHeight;
    ctx.translate(36 + lineWidthXPos, offset + implantHeight / 2);
    ctx.rotate(-Math.PI / 2);
    ctx.fillText(this.props["Width cm"] || "", 0, 0);
    ctx.restore();
    ctx.save();
    ctx.fillStyle = "black";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.translate(implantGraphSizeX, implantGraphSizeY / 2);
    ctx.rotate(-Math.PI / 2);
    // ctx.font = '9px Arial';
    // ctx.fillText('PROJECTION', 0, 10);
    ctx.restore();
  };

  drawLineHeight = implantSizeX => {
    const { ctx, implantGraphSizeX, implantGraphSizeY } = this.state;
    ctx.save();
    ctx.beginPath();
    let offset = implantGraphSizeX - implantSizeX;
    ctx.translate(offset, implantGraphSizeY);
    ctx.strokeStyle = "#20619b";
    ctx.textAlign = "center";
    ctx.font = "44px Arial";
    ctx.font = "bold 40pt Arial";
    ctx.fillStyle = "black";
    ctx.lineWidth = 8;
    ctx.moveTo(0, -4 * 4);
    ctx.lineTo(0, 4 * 4);
    // for (let i = 0; i < implantSizeX - offset; i += 5 * 4) {
    //   ctx.moveTo(i, -3 * 4);
    //   ctx.lineTo(i, +3 * 4);
    // }
    ctx.moveTo(0, 0);
    ctx.lineTo(implantSizeX - offset, 0);
    ctx.moveTo(implantSizeX - offset, -4 * 4);
    ctx.lineTo(implantSizeX - offset, 4 * 4);
    ctx.stroke();
    ctx.fillText(
      this.props["Height cm"] || "",
      implantSizeX / 2 - offset / 2,
      -12 * 3
    );
    // ctx.font = '9px Arial';
    // ctx.fillText('DIAMETER', implantSizeX / 2 - offset / 2, 22);
    ctx.restore();
  };

  drawHelperLines = ctx => {
    // let offsetX = 12;
    // let offsetY = 0;
    // let height = 75;
    // let width = 210;
    // let bottom = height;
    // let implantSize = 60;
    // ctx.lineWidth = 1;
    // ctx.fillStyle = '#666';
    // ctx.strokeStyle = 'grey';
    // ctx.textAlign = 'center';
    // ctx.font = '14px Arial';
    // this.drawLines(ctx, offsetX, offsetY, 225, 70);
    // ctx.strokeRect(offsetX, offsetY, width, height);
    // //this.implant(ctx, canvas.width / 2, bottom, 200, implantSize);
    // // this.drawLineWidth(ctx, bottom, offsetX, implantSize);
    // //  this.drawLineHeight(ctx, 20, 98, 225, 5);
    // ctx.font = '16px Arial';
    // ctx.fillStyle = 'black';
    // ctx.fillText(this.props.Volume || '', canvas.offsetWidth / 2 + 16, 25);
  };

  cross = (ctx, x, y, color = "red") => {
    let initColor = ctx.fillStyle;
    ctx.fillStyle = color;
    ctx.fillRect(x - 2, y, 5, 1);
    ctx.fillRect(x, y - 2, 1, 5);
    ctx.fillStyle = initColor;
    ctx.stroke();
  };

  drawBox = () => {
    const {
      ctx,
      implantBoxOffsetY,
      implantGraphOffsetX,
      implantGraphOffsetY,
      implantGraphSizeX,
      implantGraphSizeY
    } = this.state;
    ctx.imageSmoothingEnabled = false;

    ctx.save();
    ctx.translate(implantGraphOffsetX + 0.5, implantGraphOffsetY + 0.5);
    ctx.lineWidth = 8;
    ctx.strokeStyle = "#d3d3d3";
    ctx.fillStyle = "white";
    ctx.rect(0, implantBoxOffsetY, implantGraphSizeX, implantGraphSizeY);
    ctx.stroke();
    ctx.fill();
    this.drawLines();
    this.drawImplant();
    ctx.fillStyle = "grey";
    ctx.textAlign = "right";
    ctx.font = "bold 70pt Arial";
    ctx.fillText(this.props.Volume, implantGraphSizeX - 5 * 4, 20 * 4);
    // ctx.textAlign = "left";
    // ctx.fillText(
    //   this.props.Model + " - " + this.props["Product Code"],
    //   5,
    //   9 * 4
    // );
    ctx.restore();
  };

  drawImplant() {
    const {
      ctx,
      implantGraphSizeX,
      implantGraphSizeY,
      implantBottomCornerCurves,
      implantCurveBreakPoint,
      implantSizeX,
      implantSizeY
    } = this.state;
    ctx.beginPath();
    ctx.lineWidth = 8;
    ctx.strokeStyle = "#d3d3d3";
    let x = implantGraphSizeX / 2;
    let y = implantGraphSizeY - 2;
    ctx.moveTo(x, y);
    ctx.lineTo(x - x * implantBottomCornerCurves, y);

    // ctx.moveTo(posX + posX * implantBottomCornerCurves, posY);
    this.cross(ctx, x, y);
    let round = 1;
    if (this.props.Type === "Rund") round = 1.5;
    else if (this.props.Type === "Rund Xtra") round = 2.3;

    if (this.props.Projection === "HP") round = round + 0.1;
    else if (this.props.Projection === "M+") round = round + 0.2;
    else if (this.props.Projection === "MP") round = round + 0.3;

    let orgSizeY = Number(this.props["Width cm"].replace(",", "."));
    const implantHeight = ~~(implantSizeY + orgSizeY + orgSizeY * 4 * round);
    let orgSizeX = Number(this.props["Height cm"].replace(",", "."));
    const implantWidth = ~~(
      implantSizeX +
      orgSizeX +
      orgSizeX * 4 -
      round * orgSizeX
    );

    let delta = 10;

    ctx.quadraticCurveTo(
      implantGraphSizeX - implantWidth + delta,
      y,
      implantGraphSizeX - implantWidth + delta,
      y - y * implantCurveBreakPoint
    );
    ctx.quadraticCurveTo(
      implantGraphSizeX - implantWidth + delta,
      implantGraphSizeY - implantHeight,
      x,
      implantGraphSizeY - implantHeight
    );
    ctx.quadraticCurveTo(
      implantWidth + delta,
      implantGraphSizeY - implantHeight,
      implantWidth + delta,
      y - y * implantCurveBreakPoint
    );
    ctx.quadraticCurveTo(
      implantWidth + delta,
      y,
      implantWidth + delta - x * implantBottomCornerCurves,
      y
    );
    ctx.closePath();
    ctx.fillStyle = "rgba(230,230,230,0.7)";
    ctx.fill();
    ctx.stroke();

    this.drawLineWidth(implantHeight);
    this.drawLineHeight(implantWidth);
  }

  componentDidMount = () => {
    let ctx = this.canvas.current.getContext("2d");
    this.setState({ ctx: ctx });
  };

  componentDidUpdate = () => {
    this.canvas.current.width = this.canvas.current.width;
    this.drawBox();
  };

  render() {
    return (
      <canvas
        ref={this.canvas}
        className="product-image"
        width={this.state.canvasWidth}
        height={this.state.canvasHeight}
      />
    );
  }
}

export default ProductCanvas;
